<template>
  <p class="data-table-heading">{{ dataPoint.label.value }}</p>

  <div class="data-table-wrapper">
    <div v-if="!comparisonCount" class="d-flex justify-center items-center py-4"><em>Add a car to compare</em></div>

    <template v-else v-for="(carData, carIndex) in carsToCompare" :key="`car__${carIndex}`">
      <template v-if="objectHasEntries(carData)">
        <div :class="carsToCompareClasses(carData, carIndex)">
          <div :class="`mobile-color-band car-${carIndex}`" />

          <span class="data-table-value" v-html="getDataValue({ carData, dataPoint })" />

          <div class="data-table-vehicle" v-if="carData">
            <small class="text-right text-cool-grey" v-text="comparisonStore.getCarYearRange(carData?.Vehicle_UID)" />
            <span class="data-table-vehicle__make-model">{{ carData.Make }} {{ carData.Model }} {{ carData.Trim }}</span>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { objectHasEntries } from '../../foundation/helpers';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';

const props = defineProps<{
  dataPoint: any;
  carsToCompare: any[];
  getDataValue: Function;
}>();

// Pinia Store values
const comparisonStore = useCarComparisonStore();
const comparisonCount = computed(() => comparisonStore.vehicleIdsInCart.length);

// Computed values
const carsToCompareClasses = computed(() => (carData: any, index: number) => {
  return [
    `data-table-item item-${index}`,
    {
      'car-available': carData?.Vehicle_UID,
      'last-item': index === comparisonCount.value,
    },
  ];
});
</script>

<style lang="scss" scoped>
.data-table-heading {
  color: $racq-cool-grey;
  font-weight: bold;
  font-family: $arial-regular-font;
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;

  &:first-of-type {
    margin-top: 0;
  }
}

.data-table-value {
  padding-left: 0.5rem;
  align-self: center;
  max-width: 15rem;
}

.data-table-vehicle {
  display: flex;
  text-align: right;
  flex-direction: column;
  justify-items: end;
  margin-left: auto;
  padding-right: 0.25rem;
  max-width: 50%;

  &__make-model {
    text-align: right;
    font-size: 0.875rem;
    color: $racq-dark-grey;
    line-height: 1;
  }
}

.data-table-wrapper {
  border: 1px solid $racq-pale-blue-border;
  border-radius: 0.25rem;
}

.data-table-item {
  padding: 0.5rem 0.25rem;
  display: flex;

  &.car-available:not(.last-item) {
    position: relative;

    // Add a nice <hr /> border effect
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 1px;
      width: 95%;
      border-bottom: 1px solid $racq-car-advisory-pale-blue;
    }
  }
}
</style>
